import { BpmRoleAssignmentRoleFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

export function BpmRoleAssignmentRole({
  data,
}: {
  data?: Hidable<BpmRoleAssignmentRoleFragment>;
}) {
  return (
    <Value data={data}>
      {(assignment) => <LocalizedName data={assignment.role.value} />}
    </Value>
  );
}
